// api service calls should be written here (Service ajax calls are managed using Using Axios Library)
export const GetLocations = () => {

  return $.get('Location/GetLocations')

}
export const GetPools = (locationid) => {
  if (!locationid) locationid = 0
  return $.get('Pool/GetPools?locationId=' + locationid)

}

export const GetLocationsPools = () => {
  let needpool=true;
  return $.get('Location/GetLocations?havingPools='+needpool)

}





// WEBPACK FOOTER //
// ./src/components/Location-Pool-Selector/Location-Pool-Selector.services.js